/* Use the existing Flickity instance so navigation and video lifecycle stay together. */
(() => {
  const attached = new WeakSet();
  function connect(root) {
    const main = root.querySelector('.slideshow-outer');
    if (!main) return null;
    const carousel = window.Flickity?.data(main);
    root.dataset.bestekHeroNavigation = carousel ? 'ready' : (window.Flickity ? 'waiting' : 'library-unavailable');
    if (!carousel) return null;
    if (!attached.has(main)) {
      attached.add(main);
      const update = () => root.querySelectorAll('[data-bestek-hero-index]').forEach(button => {
        button.setAttribute('aria-pressed', String(Number(button.dataset.bestekHeroIndex) === carousel.selectedIndex));
      });
      carousel.on('select', update);
      update();
    }
    return carousel;
  }
  function start() {
    document.querySelectorAll('.bestek-home-hero').forEach(root => connect(root));
    window.addEventListener('load', () => document.querySelectorAll('.bestek-home-hero').forEach(root => connect(root)), {once:true});
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-bestek-hero-index]');
      if (!button) return;
      const root = button.closest('.bestek-home-hero');
      const carousel = root && connect(root);
      if (!carousel) return;
      event.preventDefault();
      carousel.selectCell(Number(button.dataset.bestekHeroIndex));
    });
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.bestek-home-hero').forEach(root => connect(root)));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
